import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import moment from "moment";

// Helpers
import { orderStatusToSpanish } from "@/plugins/subscriptions_helper";
import { localCurrency } from "@/plugins/currency";
import { openWALink } from "@/plugins/subscriptions_helper";

// External components
import SubscriptionStatusBadge from "@/components/subscriptionStatusBadge/subscriptionStatusBadge";
import OrdersHistoryCard from "@/components/ordersHistoryCard/ordersHistoryCard";
import Pagination from "@/components/pagination/pagination";

@Component({
  methods: {
    moment,
    orderStatusToSpanish,
    localCurrency,
    openWALink,
  },
  components: {
    SubscriptionStatusBadge,
    OrdersHistoryCard,
    Pagination,
  },
})
export default class OrdersHistoryTable extends Vue {
  @Action action_getOrdersHistory;

  @Getter getSubscription;
  @Getter getCity;
  @Getter getIsUnderMobile;

  @Mutation SPINNER;
  @Mutation CURRENT_ORDER;

  orders = [];
  pagination = {
    total_pages: null,
    per_page: null,
    total_objects: null,
  };
  currentPage = 1;

  get getSortedOrders() {
    const compareIds = (a, b) => (a.id - b.id) * -1;
    return this.orders.sort(compareIds);
  }

  async mounted() {
    this.fetchOrders();
  }

  @Watch("currentPage")
  async fetchOrders() {
    try {
      this.SPINNER(true);
      const { orders, meta } = await this.action_getOrdersHistory({
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        page: this.currentPage,
        perPage: 10,
      });
      this.orders = orders;
      this.pagination = meta.pagination;
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al obtener las ordenes. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }

  orderDetailsToRow(orderDetails) {
    let response = "";
    orderDetails.forEach((menu, index) => {
      response += `${menu.count} x ${menu.menu_name}`;
      if (index - 1 !== orderDetails.length) response += ", ";
      else response += ".";
    });
    return response;
  }

  seeOrderDetails(order) {
    this.CURRENT_ORDER(order);
    this.$router.push({ name: "ordersHistoryDetail", params: { orderId: order.id } });
    document.getElementById("SubscriptionDashboard").scroll({ top: 0, left: 0, behavior: "auto" });
  }
}
